import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo } from 'react';
import Button from 'src/components/design-system/Button';
import useViewMessage from 'src/hooks/useViewMessage';

interface ClearFiltersProps {
  clearFilter: () => void;
  deletedFilter?: { value: string; label: string };
}

const ClearFilters = ({ clearFilter, deletedFilter }: ClearFiltersProps) => {
  const { messagesDataState, t } = useViewMessage();

  const isClearFiltersDisabled = useMemo(() => {
    // Check both grid column filters and toolbar dropdown state
    const hasGridFilters = (messagesDataState.filter?.filters?.length ?? 0) > 0;
    const dropdownValue = deletedFilter?.value?.trim().toLowerCase();
    const dropdownLabel = deletedFilter?.label?.trim().toLowerCase();
    const isShowAllActive =
      dropdownLabel === 'show all active' ||
      dropdownValue === 'not deleted' ||
      dropdownValue === 'all' ||
      !dropdownValue;
    const hasDropdownFilter = !isShowAllActive;

    return !hasGridFilters && !hasDropdownFilter;
  }, [messagesDataState.filter, deletedFilter]);

  return (
    <Button
      onClick={clearFilter}
      disabled={isClearFiltersDisabled}
      className={isClearFiltersDisabled ? '!bg-transparent' : ''}
      endIcon={<FontAwesomeIcon icon={faCircleXmark} />}
      color="transparent"
    >
      {t('Clear Filters')}
    </Button>
  );
};

export default ClearFilters;
